module.exports = __webpack_public_path__ + "static/1-0a0605f63063715c334657fdc78c1381.jpg";